module.exports = __webpack_public_path__ + "img/FZLC_4.5a3f346b.jpg";